import palette from './Palette';
import typography from '../Common/Typography';
import constants from '../Common/Constants';
import buildTheme from '../Common/Theme';

export default buildTheme(palette, typography, constants);